import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportFluxoCaixaUseCase } from "../../../presentation/useCases/read/get_report_fluxo_caixa_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from '../../repositories/reports_repository';

/**
 * GetReportFluxoCaixaUseCase
 */

export class GetReportFluxoCaixaUseCase implements IGetReportFluxoCaixaUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async execute(
    requiredMimeType: ReportMimeType | null,
    idsBancoPagamento: number[],
    idsCentroCusto: number[],
    statusPagamento: number | null,
    statusRecebimento: number | null,
    dataDe: Date | null,
    dataAte: Date | null,
    idFornecedor: number | null,
    idCliente: number | null,
    isEstoque?: boolean
  ): Promise<ReportData> {

    const centroCustoStr = idsCentroCusto?.length > 0 ? idsCentroCusto.filter(x => x !== 0).join(',') : null;
    const bancoPagamentoStr = idsBancoPagamento?.length > 0 ? idsBancoPagamento.filter(x => x !== 0).join(',') : null;

    const response = await this.repository.getReportFluxoCaixaLista(
      requiredMimeType ?? "text/html",
      bancoPagamentoStr,
      centroCustoStr,
      statusPagamento,
      statusRecebimento,
      dataDe,
      dataAte,
      idFornecedor,
      idCliente,
      isEstoque
    );

    const today = new Date().toLocaleDateString('pt-BR').replace(/\//g, '_');
    if (response.mimeType !== "text/html") {
      const arquivoData = response.bytes;
      const arquivoNome = idsBancoPagamento === undefined
        ? `fluxo_caixa_lista_${today}.${response.filenameExtension}`
        : `fluxo_caixa_${today}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;
  }
}
